export const FeatureFlag = {
  RedirectToAppCdt: 'enabledRedirectToAppCdt',
  PixAutomatic: 'enabledPixAutomatic',
} as const

export const LAUNCHDARKLY_INIT_TIMEOUT_SECONDS = 2
